import {
  allContactApi,
  deleteContactApi,
  deleteContactManyApi,
} from "services/customAPI";
import ColumnsTable from "./components/ColumnsTable";
import { createContext, useEffect, useRef, useState } from "react";
import { useDisclosure } from "@chakra-ui/hooks";
import {
  Button,
  ChakraProvider,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "../../../assets/svg/deleteIcon.svg";
import ReactPaginate from "react-paginate";
import { Spinner } from "@chakra-ui/react";
import Navbar from "components/navbar";
import { useDispatch, useSelector } from "react-redux";
import { resetFields, setText } from "redux/reducers/searchSlice";

const Tables: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const currentPage = useRef<number>(1);
  const navigate = useNavigate();
  const [alldata, setAllData] = useState([]);
  const [limit, setLimit] = useState<number>(10);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [modalState, setModalState] = useState(true);
  const [selectedItem, setSelectedItem] = useState(null);
  const [pageItemStartNumber, setPageItemStartNumber] = useState<number>(1);
  const [pageItemEndNumber, setPageItemEndNumber] = useState<number>(limit);
  const [pageCount, setPageCount] = useState<number>(1);
  const searchObject = useSelector((store: any) => store?.search);
  const dispatch = useDispatch();
  const [isNavBar, setIsNavBar] = useState(true);
  const [deleteMultiple, setDeleteMultiple] = useState<any>([]);
  const [deleteMultipleDisp, setDeleteMultipleDisp] = useState<any>([]);

  useEffect(() => {
    console.log({ deleteMultiple });
  }, [deleteMultiple]);

  // const [searchText, setSearchText] = useState(searchObject);

  // useEffect(()=>{
  //   console.log({searchObject},{searchText})
  // },[searchObject,searchText])
  let setSearchText = (text: any) => {
    dispatch(setText(text));
  };

  let handleNavBar = () => {
    setIsNavBar(!isNavBar);
  };

  let setCurrentPage = () => {
    currentPage.current = 1;
  };

  async function convertToUsableArray(dataArray: any) {
    const res = Promise.all(
      dataArray.map(async (data: any) => {
        let path;
        return {
          name: data.name,
          designation: data.designation,
          project: data.project,
          department: data.department,
          mobileNumber: data.mobileNumber,
          action: {
            id: data._id,
          },
        };
      })
    );

    return res;
  }

  const setPageItemRange = (
    currPageNumber: number,
    maxItemRange: number
  ): void => {
    let startNumber = currPageNumber * limit - limit + 1;
    if (startNumber < 0) {
      startNumber = 0;
    }
    setPageItemStartNumber(startNumber);

    const endNumber = currPageNumber * limit;
    setPageItemEndNumber(Math.min(endNumber, maxItemRange));
  };
  const allContacts = async () => {
    // console.log({searchText})
    try {
      setIsLoading(true);
      const response: any = await allContactApi({
        page: currentPage.current,
        limit: limit,
        searchObject: searchObject,
      });
      setAllData(await convertToUsableArray(response?.userData[0]?.data));
      setPageItemRange(
        currentPage.current,
        response?.userData[0]?.count[0]?.totalcount
      );
      setPageCount(
        Math.ceil(response?.userData[0]?.count[0]?.totalcount / limit)
      );
    } catch (error) {
      console.log("allcontact api error", error);
    } finally {
      setIsLoading(false);
    }
  };

  function handlePageClick(event: any) {
    setIsLoading(true);
    currentPage.current = event.selected + 1;
    // if (searchText !== "") {
    //   searchRiderFunction();
    // } else {
    allContacts();
    // }
  }

  const handleClickForDeleteModal = (data: any) => {
    console.log("delete data", data);
    setIsLoading(true);
    setModalState(true);
    setSelectedItem(data);
    onOpen();
    setIsLoading(false);
  };

  const handleClickForDeleteModalMany = (data: any) => {
    setIsLoading(true);
    setModalState(true);
    setSelectedItem(data);
    onOpen();
    setIsLoading(false);
  };

  const deleteHandle = async (data: any) => {
    setIsLoading(true);
    onClose();
    try {
      const response: any = await deleteContactApi(data);
      navigate(`/admin/contacts`);
      allContacts();
      setIsLoading(false);
    } catch (error: any) {
      setIsLoading(false);
    }
  };

  const deletemanyHandle = async (data: any) => {
    setIsLoading(true);
    onClose();
    try {
      const response: any = await deleteContactManyApi(data);
      setDeleteMultiple([]);
      setDeleteMultipleDisp([]);
      navigate(`/admin/contacts`);
      allContacts();
      setIsLoading(false);
    } catch (error: any) {
      setIsLoading(false);
    }
  };
  const handleSearchSubmit = async (e: any) => {
    e.preventDefault();
    console.log("object  searchText :>> ");
    allContacts();
    // if (searchText.trim() == "") {
    //   setNoData(true);
    //   return;
    // }
    // currentPage.current = 1;
    // searchDriverFunction();
  };

  useEffect(() => {
    allContacts();
  }, []);

  useEffect(() => {
    console.log({ searchObject });
  }, [searchObject]);

  return (
    <div>
      <Navbar
        flag={false}
        // flag={isNavBar ? true : false}
        brandText="Drivers"
        handleSearch={(e: React.SyntheticEvent<EventTarget>) =>
          handleSearchSubmit(e)
        }
        setSearchText={setSearchText}
        setCurrentPage={setCurrentPage}
      />
      {/* {!noData ? (
        <Card extra={" m-4 w-full p-4 h-full"}>
          <div className="m-4 text-center">
            <h2 style={{ fontSize: "30px" }}>No Results !</h2>
          </div>
        </Card>
      ) : ( */}
      {isLoading ? (
        <div className="flex min-h-screen items-center justify-center">
          <ChakraProvider>
            <Spinner
              thickness="4px"
              speed="0.999s"
              emptyColor="gray.200"
              color="green.500"
              size="xl"
            />
          </ChakraProvider>
        </div>
      ) : (
        <div>
          <div className="mt-5">
            <ColumnsTable
              allContacts={allContacts}
              tableData={alldata}
              handleClickForDeleteModal={handleClickForDeleteModal}
              setSearchText={setSearchText}
              handleNavBar={handleNavBar}
              setCurrentPage={setCurrentPage}
              deleteMultiple={deleteMultiple}
              setDeleteMultiple={setDeleteMultiple}
              setDeleteMultipleDisp={setDeleteMultipleDisp}
              handleClickForDeleteModalMany={handleClickForDeleteModalMany}
            />
            <div
              className="mx-2 "
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                color: "#5E6278",
              }}
            >
              {alldata.length > 0 && (
                <>
                  {isNavBar && (
                    <>
                      <h5>
                        {pageItemStartNumber} - {pageItemEndNumber}
                      </h5>
                      <div style={{ marginTop: "1rem" }}>
                        <ReactPaginate
                          breakLabel=" .  .  . "
                          nextLabel=">"
                          onPageChange={handlePageClick}
                          pageRangeDisplayed={3}
                          pageCount={pageCount}
                          previousLabel="<"
                          renderOnZeroPageCount={null}
                          marginPagesDisplayed={2}
                          containerClassName="pagination"
                          pageClassName="page-item"
                          pageLinkClassName="page-link"
                          previousClassName="previous-page-btn"
                          previousLinkClassName="page-link"
                          nextClassName="next-page-btn"
                          nextLinkClassName="page-link"
                          activeClassName="active"
                          forcePage={currentPage.current - 1}
                        />
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
          {isOpen && (
            <ChakraProvider>
              <Modal
                isCentered={true}
                isOpen={isOpen}
                onClose={onClose}
                size="xs"
              >
                <ModalOverlay />
                <ModalContent>
                  <ModalHeader></ModalHeader>
                  {/* <ModalCloseButton /> */}
                  <div className="mb-2 flex justify-center">
                    <img src={DeleteIcon} />
                  </div>
                  <ModalBody className="text-center">
                    Are you sure you want to Delete? <br />
                    {selectedItem?.name && '"' + selectedItem.name + '"'}
                    {!selectedItem.name &&
                      deleteMultipleDisp.map((e: any) => '"' + e + '"')}
                  </ModalBody>
                  <div className="mt-3 flex justify-center">
                    <Button
                      // style={{backgroundColor: 'red'}}
                      className="cancel-delete-modal-button mx-2"
                      onClick={onClose}
                    >
                      Cancel
                    </Button>
                    <Button
                      className="delete-modal-button mx-2 "
                      style={{ backgroundColor: "red" }}
                      onClick={() => {
                        selectedItem?.action?.id
                          ? deleteHandle(selectedItem?.action?.id)
                          : deletemanyHandle(deleteMultiple);
                      }}
                    >
                      Delete
                    </Button>
                  </div>
                  <ModalFooter></ModalFooter>
                </ModalContent>
              </Modal>
            </ChakraProvider>
          )}
        </div>
      )}
    </div>
  );
};

export default Tables;
